import { ChainId } from '@pancakeswap-libs/sdk'
import MULTICALL_ABI from './abi.json'

const MULTICALL_NETWORKS: { [chainId in ChainId]: string } = {
  [ChainId.MAINNET]: '0xbD84F72a48a3B8412e0954e03BbDC218Dd194740', // TODO
  [ChainId.BSCTESTNET]: '0x7F28D94D8dc94809a3f13e6a6e9d56ad0B6708fe'
}

export { MULTICALL_ABI, MULTICALL_NETWORKS }
